import { useState } from "react";
import { npcs } from "../content/bestiary";
import { Enemy } from "./Enemy";
import { Article } from "../_/components/Article";
import { Accordion, AccordionDetails, AccordionSummary } from "../_/components/AccordionStyled";


interface Params {
  title: string;
}

export const Bestiary = () => { return (
  <>
    <Article.Title>Bestiariusz</Article.Title>
    <Article.SubTitle>Bohaterowie niezależni</Article.SubTitle>
    <Article.Body>
      Jeśli chodzi o statystyki, bohaterowie niezależni podlegają takim samym zasadom jak postacie bohaterów.
      Ich  poziom powinien odpowiadać ich ogólnemu doświadczeniu a ich statystyki i atuty ich naturalnym predyspozycją i zdolnością.
      Wyjątkiem są przypadkowi przechodnie których wszystkie statystyki są równe 0, poza jedną wiodącą, mają jeden najlepiej opisujący ich atut i/lub wadę.
      ich życie jest równe 5 a zamiast atakować w walce uciekają.
    </Article.Body>

    <Article.SubTitle>Wrogowie</Article.SubTitle>
    <Article.Body>
      Pod względem mechanicznym wrogowie to Bohaterowie niezeleżni, których cele stoją w sprzeczności z celami graczy.
      Czasem wystarczy wyeliminować przyczynę sporu aby go zakończyć innym razem może okazać, że jedynym wyjściem jest walka.
      Siła z jaką wróg bedzie bronił swoich celów określa jego Determinacja. Słabo opłacani strażnicy mogą mieć Determinację równą 1,
      podczas gdy Determinacja straży królewskiej może osiągać nawet 10.
    </Article.Body>

    <Article.SubTitle>Zagrożenia</Article.SubTitle>
    <Article.Body>
      Zagrożenia to mechanizm pozwalający przedstawić niesprzyjające warunki lub wielu wrogów traktując ich jako grupę.
      Zagrożenie definiuje efekt jaki wywołuje oraz ewentualny sposób na jego ograniczenia lub wyeliminowania. 
      Przykłady: Trujące opary, rój pszczół, rozwścieczony tłum, grupa orków 
    </Article.Body>

    <Article.SubTitle>Bossowie</Article.SubTitle>
    <Article.Body>
      Bossowie to bohaterowie niezależni o nieprzeciętnej mocy. Starcie z nimi powinno być wymagającym i unikalnym przeżyciem, dlatego bossom mogą towarzyszyć
      Zagrożenia, moga oni posiadać unikalne mechaniki a walka z nimi może odbywać się w etapach.
    </Article.Body>
  </>)
}

export const Bestiary2 = () => {
  const [open, setOpen] = useState(true);
  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <Article.Title>Bestiariusz</Article.Title>
      <Accordion>
        <AccordionSummary>
          <Article.SubTitle>Przykładowe postacie niezależnie</Article.SubTitle>
        </AccordionSummary>
        <AccordionDetails>
          {npcs.map(enemy => <Enemy enemy={enemy} />)}
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary>
          <Article.SubTitle>Przeciwnicy</Article.SubTitle>
        </AccordionSummary>
        <AccordionDetails>
          {npcs.map(enemy => <Enemy enemy={enemy} />)}
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary>
          <Article.SubTitle>Zagrożenia</Article.SubTitle>
        </AccordionSummary>
        <AccordionDetails>
          {npcs.map(enemy => <Enemy enemy={enemy} />)}
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary>
          <Article.SubTitle>Bossowie</Article.SubTitle>
        </AccordionSummary>
        <AccordionDetails>
          {npcs.map(enemy => <Enemy enemy={enemy} />)}
        </AccordionDetails>
      </Accordion>

    </>
  )
}


const Gallery = () => {
  const items = ['1', '2', '3']
  return (
    <div className="gallery-grid">
      {items.map((item, index) => (
        <div key={index} className="gallery-item">

          <div className="overlay">
            <div className="caption">{item}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Gallery;